module.exports = "<div class=\"wrapper-content row table-responsive\">\n  <registration-form [fields]=\"fields\" (onEdit)=\"edit($event)\"></registration-form>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/sessions/registration/registration.component.html
// module id = ./src/app/modules/sessions/registration/registration.component.html
// module chunks = main